<template id="pageTable">
    <div>
        <simple-table
            :rows="rows"
            :columns="columns"
            :perPage="[10, 25, 50, 100]"
            :classes="tableClasses"
        >
            <tbody slot="body" slot-scope="{ data }">
                <tr :key="item.id" v-for="item in data">
                    <template v-if="tab == 'empleados'">
                        <td
                            style="
                                min-width: 159px !important;
                                max-width: 161px !important;
                                width: 160px;
                                padding-right: 4px;
                            "
                        >
                            <div><span :class="item.baja ? 'color-baja':''">{{ item.clave }}</span></div>
                        </td>
                        <td @click="detalleEmpleado(item)" class="cursor-pointer">
                            <div style="max-width: 30rem">
                                <v-list color="transparent" class="py-0 my-0">
                                    <v-list-item class="py-0 my-0 px-0">
                                        <v-list-item-avatar class="py-0 my-0">
                                            <v-img
                                                class="py-0 my-0"
                                                :src="urlImg + item.foto"
                                            ></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content class="ml-0 py-0 my-0">
                                            <v-list-item-title class="tblPrincipal text-wrap" >
                                                <span :class="item.baja ? 'color-baja':''">{{item.nombre_completo}}</span>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </td>
                        <td><div class="tblPrincipal"><span :class="item.baja ? 'color-baja':''">{{ item.antiguedad }}</span></div></td>
                        <td >
                            <div class="d-flex align-center justify-center">
                                <v-rating
                                    v-model="item.objRankig.length"
                                    size="24"
                                    dense
                                >
                                    <template v-slot:item="props">
                                        <v-tooltip bottom v-if="props.isFilled">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :color="props.isFilled ? '#2DB9D1' : '#F2F2F2'"
                                                    class="mx-1"
                                                >
                                                    {{ props.isFilled ? 'mdi-star' : 'mdi-star' }}
                                                </v-icon>
                                            </template>
                                            <span v-if="props.isFilled">{{item.objRankig[props.index]}}</span>
                                        </v-tooltip>

                                        <v-icon
                                            v-else
                                            :color="props.isFilled ? '#2DB9D1' : '#F2F2F2'"
                                            class="mx-1"
                                        >
                                            {{ props.isFilled ? 'mdi-star' : 'mdi-star' }}
                                        </v-icon>
                                    </template>
                                </v-rating>
                            </div>
                        </td>
                        <td><div><span :class="item.baja ? 'color-baja':''">{{ item.nombre_departamento }}</span></div></td>

                        <template
                            v-if="rol !== 'empleado'"
                        >
                            <td
                                style="
                                    min-width: 290px !important;
                                    max-width: 301px !important;
                                    width: 300px;
                                    padding-left: 8px;
                                    padding-right: 8px;
                                "
                            >
                                <div class="tblOpciones">
                                    <template v-if="item.baja === false">
                                        <v-menu
                                            buttom
                                            left
                                            class="elevation-0 d-inline"
                                            content-class="mt-0 menuClassAccionesEmpleado"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    class="elevation-0"
                                                >
                                                    <template v-for="(item, valor) in attrs">
                                                        <v-icon
                                                            :key="valor"
                                                            v-if="valor == 'aria-expanded' && item == 'false'"
                                                            class="pl-2"
                                                            color="#828282"
                                                        >
                                                            more_vert
                                                        </v-icon>
                                                        <v-icon
                                                            :key="valor"
                                                            v-if="valor == 'aria-expanded' && item == 'true'"
                                                            class="pl-2"
                                                            color="#2DB9D1"
                                                        >
                                                            more_vert
                                                        </v-icon>
                                                    </template>
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item @click="openModalInfo(item)">
                                                    <v-list-item-title>
                                                        Ver datos del empleado
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="
                                                        item.asimilado
                                                        ? abrirModalEmpleadoAsimilado('update', item)
                                                        : abrirModalEmpleado('update', item)
                                                    "
                                                    v-if="
                                                        rol == 'root' ||
                                                        rol == 'admin' ||
                                                        rol == 'admin-empresa' ||
                                                        rol == 'admin-sucursal'
                                                    "
                                                >
                                                    <v-list-item-title>
                                                        Editar empleado
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <template v-if="permisos.delete">
                                                    <v-list-item
                                                        @click="abrirModal('baja', item)"
                                                        v-if="
                                                            rol == 'root' ||
                                                            rol == 'admin' ||
                                                            rol == 'admin-empresa' ||
                                                            rol == 'admin-sucursal'
                                                        "
                                                    >
                                                        <v-list-item-title>
                                                            Dar de baja
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </template>
                                                <v-list-item
                                                    @click="abrirModalClave(item)"
                                                    v-if="!item.asimilado"
                                                >
                                                    <v-list-item-title>
                                                        Clave checador
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="detalle_documentos(item)"
                                                >
                                                    <v-list-item-title>
                                                        Documentos
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>
                                    <template v-else>
                                        <v-menu
                                            buttom
                                            left
                                            class="elevation-0 d-inline"
                                            content-class="mt-0 menuClassAccionesEmpleado"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    class="elevation-0"
                                                >
                                                    <template v-for="(item, valor) in attrs">
                                                        <v-icon
                                                            :key="valor"
                                                            v-if="valor == 'aria-expanded' && item == 'false'"
                                                            class="pl-2"
                                                            color="#828282"
                                                        >
                                                            more_vert
                                                        </v-icon>
                                                        <v-icon
                                                            :key="valor"
                                                            v-if="valor == 'aria-expanded' && item == 'true'"
                                                            class="pl-2"
                                                            color="#2DB9D1"
                                                        >
                                                            more_vert
                                                        </v-icon>
                                                    </template>
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item
                                                    v-if="rol != 'admin-depto' && rol != 'empleado'"
                                                    @click="abrirModalRestaurar(item)"  
                                                >
                                                    <v-list-item-title>Restaurar empleado</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>
                                    <v-tooltip bottom v-if="permisos.delete">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="
                                                    rol == 'root' ||
                                                    rol == 'admin' ||
                                                    rol == 'admin-empresa' ||
                                                    rol == 'admin-sucursal'
                                                "
                                                v-on="on"
                                                @click="eliminar(item)"
                                                class="botonHover"
                                                icon
                                                fab
                                                dark
                                                small
                                            >
                                                <v-icon
                                                    class="tamIconoBoton invertirColorBotonesDelete"
                                                >
                                                    delete
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </template>
                    </template>
                </tr>
            </tbody>
        </simple-table>
        <div>
            <v-dialog v-model="dialog_info" scrollable persistent max-width="720px">
                <v-card v-if="showDialoginfo">
                    <v-card-title class="justify-center">
                        <div class="col-lg-12">
                            <v-btn
                                @click="cerrarModal()"
                                small
                                slot="activator"
                                icon
                                text
                                class="v-btn-cerrar modal-pull-right"
                            >
                                <v-icon class="icono-cerrar"></v-icon>
                            </v-btn>
                        </div>
                        <v-container>
                            <div class="col-lg-12 d-flex">
                                <div class="mt-12">
                                    <div class="header">
                                        <h2 class="title">DATOS DEL EMPLEADO</h2>
                                    </div>

                                    <div class="d-flex">
                                        <v-divider class="divider-blue"></v-divider>
                                        <v-divider class="divider-gray"></v-divider>
                                    </div>

                                    <div class="row col-lg-12 pb-0 pt-7">
                                        <p class="py-0 px-0 subtitle mr-2">Nombre:</p>
                                        <p class="py-0 px-0 text" v-if="objEmpleado != null">
                                            {{ objEmpleado.nombre }}
                                            {{ objEmpleado.apellido_paterno }}
                                            {{ objEmpleado.apellido_materno }}
                                        </p>
                                    </div>

                                    <div class="row col-lg-12 py-0 mt-n1">
                                        <p class="py-0 px-0 subtitle mr-2">Tipo de empleado:</p>
                                        <p class="py-0 px-0 text" v-if="objEmpleado != null">
                                            {{ objEmpleado.asimilado ? "Asimilado" : "Asalariado" }}
                                        </p>
                                    </div>
                                    <div class="row col-lg-12 py-0 mt-n1">
                                        <p class="py-0 px-0 subtitle mr-2">Clave:</p>
                                        <p class="py-0 px-0 text" v-if="objEmpleado != null">
                                            {{ objEmpleado.clave }}
                                        </p>
                                    </div>
                                </div>
                                <div class="imgMarco">
                                    <img class="imgFoto" :src="fotoModal" />
                                </div>
                            </div>
                            <div class="col-lg-12 d-flex mt-5">
                                <v-divider class="divider-gray skiny"></v-divider>
                            </div>
                        </v-container>
                    </v-card-title>
                    <v-card-text>
                        <perfect-scrollbar style="max-height: 100%">
                            <component-info
                                :objEmpleado="objEmpleado"
                                :key="'B' + countInfoKardex"
                            >
                            </component-info>
                        </perfect-scrollbar>
                    </v-card-text>

                    <v-card-actions> </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <template>
            <v-row class="justify-center">
                <v-dialog
                    v-model="dialog_empleado"
                    scrollable
                    persistent
                    max-width="900px"
                >
                    <v-card>
                        <v-card-text class="pa-0 ma-0">
                            <ModalEmpleado
                                :title="tituloEmpleado"
                                :objEmpleado="datosEmpleado"
                                :action="accionEmpleado"
                                @cerrarModal="cerrarModalEmpleado"
                                :key="'A' + componentKey"
                            />
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-row class="justify-center">
                <v-dialog
                    v-model="dialogEmpleadoAsimilado"
                    scrollable
                    persistent
                    max-width="900px"
                >
                    <v-card>
                        <v-card-text class="pa-0 ma-0">
                            <ModalEmpleadoAsimilado
                                :title="tituloEmpleado"
                                :objEmpleado="datosEmpleado"
                                :action="accionEmpleado"
                                @cerrarModal="cerrarModalEmpleado"
                                :key="'A' + componentKey"
                            />
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-dialog v-model="dialog" persistent :max-width="tamModal">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>

                <!-- card de baja de empleado -->
                <v-card>
                    <ValidationObserver ref="form" v-slot="{ invalid }">
                        <v-card-title class="justify-center titulo mb-0 pt-50px">
                            <div class="headerModal">
                                <img :src="imagen" class="imgModal" />
                                <h2 class="titleModal">{{ tituloModal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="px-50px">
                            <div id="padre" v-show="isLoading">
                                <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container v-show="!isLoading" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Nombre"
                                            class="pa-0 ma-0"
                                            v-model="nombreBaja"
                                            disabled
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                        <VuetifyDatePicker
                                            outlined
                                            v-model="baja.fecha"
                                            :valorDefecto="baja.fecha"
                                            label="Fecha de baja"
                                            placeholder="dd/mm/aaaa"
                                            rules="required"
                                            ref="FechaBaja"
                                        />
                                    </v-col>
                                    <v-col
                                        xs="12"
                                        sm="12"
                                        md="12"
                                        class="py-0"
                                        v-if="!datosEmpleado.asimilado"
                                    >
                                        <ValidationProvider
                                            v-slot="{ errors }"
                                            name="Tipo de baja"
                                            rules="required"
                                        >
                                            <v-autocomplete
                                                outlined
                                                :items="tipos_baja_imss"
                                                item-text="descripcion"
                                                item-value="id"
                                                label="Tipo de baja ante el IMSS"
                                                persistent-hint
                                                v-model="baja.tipo_baja_imss_id"
                                                :error-messages="errors"
                                                required
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                        <ValidationProvider
                                            v-slot="{ errors }"
                                            name="Motivo de la baja"
                                            rules="required"
                                        >
                                            <v-textarea
                                                class="estiloLetras"
                                                v-model="baja.motivo"
                                                label="Motivo de la Baja"
                                                outlined
                                                :error-messages="errors"
                                                required
                                            ></v-textarea>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModal()"
                                :disabled="isSaving"
                            >
                                Cerrar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="bajaEmpleado()"
                                :disabled="invalid"
                                :loading="isSaving"
                            >
                                Baja
                            </v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog v-model="dialogClave" persistent max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        style="display: none"
                        class="botonModal"
                        id="btnModalLayout"
                    ></v-btn>
                </template>
                <v-card>
                    <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                        <div class="headerModalStart">
                            <h2 class="titleModal_700_18">Clave checador</h2>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <div id="padre" v-show="isLoadingChecador">
                            <div id="loading">
                                <v-progress-circular
                                    indeterminate
                                    :size="100"
                                    :width="7"
                                    color="blue"
                                ></v-progress-circular>
                            </div>
                        </div>

                        <v-container
                            v-show="!isLoadingChecador"
                            grid-list-md
                            id="contenedor"
                        >
                            <v-divider class="divider"></v-divider>
                            <v-row>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="py-0">
                                    <table class="ml-3">
                                        <tr>
                                            <td class="textoTablaClave01">Clave del empleado:</td>
                                            <td class="textoTablaClave02">
                                                {{ claveEmpleado.clave }}
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="textoTablaClave01">Clave de seguridad:</td>
                                            <td class="textoTablaClave02">
                                                {{
                                                claveEmpleado.claveVerificacion
                                                    ? claveEmpleado.claveVerificacion
                                                    : "----"
                                                }}
                                            </td>
                                            <td>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-on="on"
                                                            class="botonHover"
                                                            icon
                                                            fab
                                                            dark
                                                            small
                                                            @click="generarClave()"
                                                        >
                                                            <v-icon class="tamIconoBoton iconoDelgadoBoton"
                                                            >
                                                                autorenew
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Generar</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <button class="btnCerrar" @click="cerrarModalClave()">
                        Cerrar
                        </button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <template >
            <v-dialog v-model="dialog_restaurar" scrollable persistent max-width="600px" class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModalRestaurar" style="display: none"></v-btn>
                </template>
                <v-card class="borde-card">
                    <perfect-scrollbar style="height:100%;">
                        <ValidationObserver ref="formRestaurar" v-slot="{ invalid }">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagen" class="imgModal" />
                                    <h2 class="titleModal">{{ tituloModal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="padre" v-show="isLoading">
                                    <div id="loading">
                                        <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                    </div>
                                </div>
                                
                                <v-container v-show="!isLoading" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="12" class="py-0" >
                                            <v-text-field
                                                outlined
                                                readonly
                                                v-model="dataEmpleado.nombre_completo"
                                                label="Nombre"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                            <VuetifyDatePicker
                                                outlined
                                                rules="required"
                                                v-model="fechaRestaurar"
                                                :valorDefecto="fechaRestaurar"
                                                label="Fecha"
                                                placeholder="dd/mm/aaaa"
                                                ref="FechaRestaurar"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()" 
                                    :disabled="isSaving"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="restaurarEmpleado()" 
                                    :disabled="invalid" 
                                    :loading="isSaving"
                                >
                                    Restaurar
                                </v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </perfect-scrollbar>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import empleadosApi from "@/api/empleados";
import apiTipoBajaImss from "@/api/nominas/tipoBajaImss";
import apiRelojChecador from "@/api/registros";
import urlImg from '../plugins/Urlimagen';
import Datatable from "@/components/simpletable/Datatable.vue";
import Star from '@/components/rating/Star.vue';
import GetUrlImg from "@/plugins/Urlimagen";
import Notify from "@/plugins/notify";
import ComponentInfo from "@/views/Kardex/Modal/ModalKardexInfo.vue";
import ModalEmpleado from "@/views/Kardex/Modal/ModalKardex.vue";
import ModalEmpleadoAsimilado from "@/views/Kardex/Modal/ModalKardexAsimilado.vue";
import VuetifyDatePicker from "@/components/VuetifyDatePicker.vue";

export default {
    components: {
        'rating-star' : Star,
        'simple-table': Datatable,
        ComponentInfo,
        ModalEmpleado,
        ModalEmpleadoAsimilado,
        VuetifyDatePicker
    },
    props: {
        tab: String,
        rol: String,
        columns: Array,
        rows: Array,
    },
    data() {
        return {
            urlImg   : urlImg.getURL(),
            months   : ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            tableClasses: {
                "t-head" : {
                    "tamanio-head":true
                }
            },
            datosLogin              : null,
            tamModal                : "500px",
            imagen                  : "/static/modal/empleadoBaja.svg",
            dialog_info             : false,
            showDialoginfo          : false,
            objEmpleado             : null,
            datosEmpleado           : null,
            componentKey            : 0,
            countInfoKardex         : 0,
            tituloEmpleado          : null,
            tituloModal             : null,
            accionEmpleado          : null,
            dialog_empleado         : false,
            dialogEmpleadoAsimilado : false,
            dialog                  : false,
            isLoading               : false,
            isSaving                : false,
            accion                  : null,
            nombreBaja              : "",
            tipos_baja_imss         : [],
            baja                    : {
                id                  : null,
                tipo_baja_imss_id   : null,
                rol_name            : null,
                accion              : "Baja",
                motivo              : "",
                fecha               : "",
                usuario_id          : null,
                email               : "",
            },
            claveEmpleado           : {
                clave: null,
                claveVerificacion: null,
            },
            dialogClave             : false,
            isLoadingChecador       : false,

            //Restaurar empleado
            dialog_restaurar    : false,
            dataEmpleado        : null,
            fechaRestaurar      : null,


            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        }
    },
    methods: {
        getColorTextoStatus(statusIncidencia){
            if (statusIncidencia == "estatus_aprobado") return "#15D511";
            if (statusIncidencia == "estatus_rechazado") return "#EE1616";
            if (statusIncidencia == "estatus_pendiente") return "#FF9B05";
            if (statusIncidencia == "estatus_revision") return "#F8690E";
        },
        dateFormat(fecha) {
            let fecha2 = fecha.split("-");
            return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
        },
        detalleEmpleado(data) {
            this.$session.remove("detalleEmpleado");
            this.$session.set("detalleEmpleado", data);
            this.$router.push("/kardex/detalleEmpleado");
        },
        openModalInfo(itemEmpleado) {
            this.countInfoKardex = this.countInfoKardex + 1;
            this.showDialoginfo = true;
            this.objEmpleado = itemEmpleado;
            this.fotoModal = GetUrlImg.getURL() + itemEmpleado.foto;
            this.dialog_info = true;
        },
        abrirModalEmpleado(accion, item = null) {
            this.componentKey += 1;
            this.datosEmpleado = item;
            this.tituloEmpleado =
            accion == "update" ? "Actualizar empleado" : "Registrar empleado";
            this.accionEmpleado = accion;
            this.dialog_empleado = true;
        },
        abrirModalEmpleadoAsimilado(accion, item = null) {
            this.componentKey += 1;
            this.datosEmpleado = item;
            this.tituloEmpleado =
            accion == "update" ? "Actualizar empleado" : "Registrar empleado";
            this.accionEmpleado = accion;
            this.dialogEmpleadoAsimilado = true;
        },
        cerrarModalEmpleado(data) {
            this.datosEmpleado = null;
            if (data == "cancelar") {
                this.dialog_empleado = false;
                this.dialogEmpleadoAsimilado = false;
            }
            if (data == "guardarCerrar") {
                this.dialog_empleado = false;
                this.dialogEmpleadoAsimilado = false;
                this.$emit('updateSearch', 'empleados');
            }
        },
        abrirModal(accion, item = null) {
            this.getBajaImss();
            this.accion = accion;
            this.isLoading = true;
            this.tituloModal = "Baja del empleado";
            this.baja.rol_name = this.datosLogin.rol.name
            this.nombreBaja = item.nombre_completo
            this.baja.id = item.id;
            this.baja.usuario_id = this.datosLogin.id;
            this.baja.email = item.correo;
            this.datosEmpleado = item;
            this.isLoading = false;
            this.baja.confirmacion = false
            setTimeout(() => {
                document.getElementById("btnModal").click();
            }, 100);
        },
        async getBajaImss() {
            let param = { activo: true, paginate: false };
            await apiTipoBajaImss.find(param).then((response) => {
                this.tipos_baja_imss = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast(
                    "Ocurrió un error al cargar los tipos de baja IMSS"
                );
            });
        },
        bajaEmpleado() {
            this.$refs.form.validate().then((success) => {
                this.isSaving = true;
                if (!success) {
                    this.isSaving = false;
                    return;
                }
                this.baja.confirmacion = false
                empleadosApi.eliminarEmpleado(this.baja).then((response) => {
                    if(response.status == 202){
                        this.isSaving = false
                        Notify.Alert(
                          "ADVERTENCIA",
                          "¿El colaborador cuenta con nómina acumulada, desea dar de baja?",
                          "Dar de baja",
                          () => {
                              this.baja.confirmacion = true;
                              this.isSaving = true;
                              empleadosApi.eliminarEmpleado(this.baja).then(response => {
                                     this.cerrarModal();
                                    Notify.Success(
                                        "Baja de Colaborador",
                                        "El colaborador ha sido dado de baja satisfactoriamente."
                                    );
                                    this.$emit('updateSearch', 'empleados');
                              })
                              .catch(err => {
                                  this.isLoading = false;
                                  this.isSaving = false;
                                  if(typeof err.response.data.error === 'string'){
                                      Notify.ErrorToast(err.response.data.error);
                                  }else{
                                      let error = Object.values(err.response.data.error);
                                      let leyenda = ``;

                                      for (var i = 0; i < error.length; i++) {
                                          leyenda+= `* ` + error[i] + `\n`;
                                      }

                                      Notify.ErrorToast(leyenda);
                                  }
                              });
                            },
                        )
                    }
                    else if(response.status == 200){
                        this.baja.confirmacion = false
                        this.cerrarModal();
                        Notify.Success(
                            "Baja de Colaborador",
                            "El colaborador ha sido dado de baja satisfactoriamente."
                        );
                        this.$emit('updateSearch', 'empleados');
                    }
                })
                .catch((err) => {
                    if (typeof err.response.data.error === "string") {
                        Notify.ErrorToast(err.response.data.error);
                    } else {
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                        leyenda += `* ` + error[i] + `\n`;
                        }

                        Notify.ErrorToast(leyenda);
                    }
                    this.isSaving = false;
                });
            });
        },
        async abrirModalClave(empleado) {
            this.isLoadingChecador = true;

            this.claveEmpleado.id = empleado.id;
            this.claveEmpleado.clave = empleado.clave;

            await this.getClave(empleado.id);

            this.dialogClave = true;
            this.isLoadingChecador = false;
        },
        cerrarModalClave() {
            this.claveEmpleado.id = null;
            this.claveEmpleado.clave = null;
            this.claveEmpleado.claveVerificacion = null;
            this.dialogClave = false;
        },
        async getClave(idEmpleado) {
            await apiRelojChecador.getCodigo(idEmpleado).then((response) => {
                this.claveEmpleado.claveVerificacion = response.codigo_verificacion;
            })
            .catch((err) => {
                console.log(err);
                this.claveEmpleado.claveVerificacion = null;
            });
        },
        async generarClave() {
            let parametros = {
                empleado_id: this.claveEmpleado.id,
            };
            await apiRelojChecador.generarCodigo(parametros).then((response) => {
                Notify.SuccessToast("Generación de clave exitosa.");
                this.getClave(this.claveEmpleado.id);
            })
            .catch((err) => {
                console.log(err);
                this.claveEmpleado.claveVerificacion = null;
                Notify.ErrorToast(
                    "Algo ha salido mal, intenta de nuevo o consulta a soporte técnico."
                );
            });
        },
        cerrarModal() {
            this.dialog = false;
            //this.dialogLayout = false;
            //this.dialogLayoutEmpleados = false;
            this.isSaving = false;
            //this.loading_guardar = false;
            this.dialog_info = false;
            this.dialog_restaurar = false;

            this.resetValues();
        },

        detalle_documentos(data) {
            this.$session.remove("documentos");
            this.$session.set("documentos", data);
            this.$router.push("/documentos");
        },
        eliminar(item) {
            Notify.Alert(
                "¿Estás seguro que deseas eliminar a este empleado?",
                "Esta acción <b>puede afectar</b> algunas funcionalidades del sistema.",
                "Eliminar",
                () => {
                    let idEmpleado = item.id;
                    let accion = "Eliminar";
                    let usuario_id = this.datosLogin.id;
                    let param = {
                        rol_name: this.datosLogin.rol.name,
                        id: idEmpleado,
                        accion: accion,
                        usuario_id: usuario_id,
                        email: item.correo,
                    };
                    empleadosApi.eliminarEmpleado(param).then((response) => {
                        Notify.Success(
                            "Colaborador eliminado",
                            "El colaborador ha sido eliminado satisfactoriamente."
                        );
                        this.$emit('updateSearch', 'empleados');
                    })
                    .catch((err) => {
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                            leyenda += `* ` + error[i] + `\n`;
                        }
                        Notify.ErrorToast(leyenda);
                    });
                },
                null,
                true,
                true
            );
        },
        resetValues(){
            this.baja = {
                id: null,
                rol_name: null,
                accion: "Baja",
                motivo: "",
                fecha: "",
                usuario_id: null,
                email: "",
                tipo_baja_imss_id: null,
            };

            this.fechaRestaurar = null;


            this.$nextTick(() => {
                this.nombreBaja = "";
                if (this.$refs.form != undefined || this.$refs.form != null) {
                    this.$refs.form.reset();
                }

                if (this.$refs.formRestaurar != undefined || this.$refs.formRestaurar != null) {
                    this.$refs.formRestaurar.reset();
                }

            });
        },

        abrirModalRestaurar(item = null){
            this.isLoading  = true;

            this.imagen = '/static/modal/empleadoUpdate.svg';

            this.tituloModal = "Restaurar empleado";
            this.dataEmpleado = item;
            this.isLoading = false;
            setTimeout(() => { document.getElementById("btnModalRestaurar").click(); }, 100);
        },
        restaurarEmpleado() {
            let self = this;

            this.$refs.formRestaurar.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }

                if(self.validarFecha(self.fechaRestaurar) == false){
                    Notify.ErrorToast(`Error en el formato de la fecha.`);
                    self.isSaving = false;
                    self.isLoading = false;
                    return;
                }

                let usuario_id = this.datosLogin.id;
                let param = {
                    id: this.dataEmpleado.id,
                    accion: "Reingreso",
                    usuario_id: usuario_id,
                    fecha: this.fechaRestaurar
                };

                empleadosApi.reingresoEmpleado(param).then((response) => {
                    this.$emit('updateSearch', 'empleados');
                    Notify.Success(
                        "Colaborador restaurado",
                        "El colaborador ha sido restaurado satisfactoriamente."
                    );
                    self.cerrarModal();
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.isSaving = false;
                    if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                    }else{
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                            leyenda+= `* ` + error[i] + `\n`;
                        }

                        Notify.ErrorToast(leyenda);
                    }
                });
            });
        },
        validarFecha(valorFecha) {
            try{
                let fecha = valorFecha.split("-");        
                let dia = fecha[2];        
                let mes = fecha[1];        
                let ano = fecha[0];        
                let estado = true;  
                let dmax = 0;
                let diaC = null;
                let mesC =  null;
                let anoC = null;
                
                if ((dia.length == 2) && (mes.length == 2) && (ano.length == 4)) {        
                    switch (parseInt(mes)) {        
                        case 1:dmax = 31;break;        
                        case 2: 
                            if (((ano % 4 == 0) && (ano % 100 != 0 )) || (ano % 400 == 0))
                                dmax = 29; 
                            else 
                                dmax = 28;        
                            break;        
                        case 3:dmax = 31;break;        
                        case 4:dmax = 30;break;        
                        case 5:dmax = 31;break;        
                        case 6:dmax = 30;break;        
                        case 7:dmax = 31;break;        
                        case 8:dmax = 31;break;        
                        case 9:dmax = 30;break;        
                        case 10:dmax = 31;break;       
                        case 11:dmax = 30;break;      
                        case 12:dmax = 31;break;       
                    }  
                    
                    dmax!=""?dmax:dmax=-1;
                    
                    if ((dia >= 1) && (dia <= dmax) && (mes >= 1) && (mes <= 12)) {
                        let i=0;
                        for (i=0 ; i<fecha[2].length; i++) {      
                            diaC = fecha[2].charAt(i).charCodeAt(0);        
                            (!((diaC > 47) && (diaC < 58)))?estado = false:'';       
                            mesC = fecha[1].charAt(i).charCodeAt(0);        
                            (!((mesC > 47) && (mesC < 58)))?estado = false:'';       
                        }  
                    } 
                    else{
                        estado = false;
                    }
                    
                    let j = 0;
                    for(j=0; j < fecha[0].length; j++) {
                        anoC = fecha[0].charAt(j).charCodeAt(0);  
                        (!((anoC > 47) && (anoC < 58)))?estado = false:'';        
                    }
                } 
                else {
                    estado = false;
                }        
                return estado; 
            }catch(err){
                return false;
            }  
        },




        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("empleados.store")
            this.permisos.update = permisosStorage.includes("empleados.update")
            this.permisos.delete = permisosStorage.includes("empleados.delete")
        }

    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.permisosVista();
    },
    mounted() {
        if(this.tab == 'empleados'){
            document.querySelector("#tableScrollSimple thead tr th:nth-child(1)").style.paddingRight = "1px";
            document.querySelector("#tableScrollSimple thead tr th:nth-child(1)").style.width = "160px";
            document.querySelector("#tableScrollSimple thead tr th:nth-child(2) div").style.marginRight = "1px";
            document.querySelector("#tableScrollSimple thead tr th:nth-child(2) div").style.margingLeft = "1px";
            //document.querySelector("#tableScrollSimple thead tr th:nth-child(6)").style.width = "310px";
            //document.querySelector("#tableScrollSimple thead tr th:nth-child(6)").style.paddingRight = "8px";
            //document.querySelector("#tableScrollSimple thead tr th:nth-child(6)").style.paddingLeft = "8px";
        }
    },
    updated() {
        if(this.tab == 'empleados'){
            document.querySelector("#tableScrollSimple thead tr th:nth-child(1)").style.paddingRight = "1px";
            document.querySelector("#tableScrollSimple thead tr th:nth-child(1)").style.width = "160px";
            document.querySelector("#tableScrollSimple thead tr th:nth-child(2) div").style.marginRight = "1px";
            document.querySelector("#tableScrollSimple thead tr th:nth-child(2) div").style.margingLeft = "1px";
            //document.querySelector("#tableScrollSimple thead tr th:nth-child(6)").style.width = "310px";
            //document.querySelector("#tableScrollSimple thead tr th:nth-child(6)").style.paddingRight = "8px";
            //document.querySelector("#tableScrollSimple thead tr th:nth-child(6)").style.paddingLeft = "8px";
        }
        
    },
}
</script>

<style>
    .fechas{
        font-size: 70%;
        font-style: oblique;
    }

    .imagen_incidencia{
        text-align:-webkit-center !important;
        text-align: -moz-center !important;
        padding-top: 5%;
    }

    .vChip{
        width:200px;
        justify-content: center;
    }

    .vChip .v-chip .v-chip__content{
        font-family: Montserrat !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        letter-spacing: -0.34px !important;
        line-height: 17px !important;
        width: 90px !important;
    }

    #chipIncidecias .v-chip{
        margin: 4px;
        height: 30px;
        white-space: nowrap !important;
    }

    .trIncidencias {
        width:200px;
    }

    .tipoLetra700Azul{
        color: #002438 !important;
        font-family: 'Montserrat';
        font-size: 14px !important;
        font-weight: 700 !important;
        letter-spacing: -0.34px !important;
        line-height: 17px !important;
        text-align: left !important;
    }

    .tipoLetra400Gris{
        color: #878EB0 !important;
        font-family: 'Montserrat';
        font-size: 14px !important;
        font-weight: 400 !important;
        letter-spacing: -0.34px !important;
        line-height: 17px !important;
    }

    .tipoLetraFecha{
        color:#D3D7EB;
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 700;
        letter-spacing: -0.43px;
        line-height: 22px;
        text-align: left;
    }

    .tipoLetra{
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 400;
        letter-spacing: -0.34px;
        line-height: 17px;
    }

    .tipoLetraNombre{
        color: #002438;
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 700;
        letter-spacing: -0.34px;
        line-height: 17px;
        text-align: left;
    }

    .departamento{
        color: #878EB0;
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 400;
        letter-spacing: -0.34px;
        line-height: 17px;
    }

    .transparente{
        background-color: transparent !important;
    }
    .cursor-pointer{
        cursor:pointer;
    }

    .divider-blue {
        z-index: 999 !important;
        max-width: 102px;
        border-radius: 50px;
        background-color: #2db9d1;
        border: 1.5px solid #2db9d1;
    }
    .divider-gray {
        margin-left: -1px;
        border: 1.5px solid #e0e0e0;
        background: #e0e0e0;
    }
    .skiny {
        margin-top: 1px;
        border: 0.5px solid #e0e0e0;
    }
    .header {
        width: 435px;
        text-align: left !important;
        margin-bottom: 15px;
    }
    .imgFoto {
        width: 100%;
        height: 100%;
    }
    .imgMarco {
        width: 191px;
        height: 199px;
        padding: 18px;
        border: 3px solid #e0e0e0;
        box-sizing: border-box;
    }
    .textoTablaClave01 {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
        text-align: left !important;
    }
    .textoTablaClave02 {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #1e2245;
        text-align: left !important;
    }
    .color-baja {
        color: #E8404E;
    }
</style>